<template>
  <div class="header-content" ref="headerContent">
    <div class="header" ref="pageHeader">
      <div class="crumbs" v-if="isCrumbs">
        <div class="crumbs-slot" v-if="$slots.crumbs">
          <slot name="crumbs"/>
        </div>
        <div class="crumbs-default" v-else>
          <breadcrumb :crumbsData="crumbsData"></breadcrumb>
        </div>
      </div>
      <div :class="['page-header']">
        <div ref="inner" class="header-inner">
          <slot v-if="$slots.head" name="head"/>
          <p v-else class="header-title font-color-primary" >
            <i class="el-icon-back header-icon" @click="handleBack" v-if="!returnHide"></i>
            <span class="header-text" :style="returnHide ? 'left: 8px;' : ''">
              {{title}}
              <slot name="tags"></slot>
            </span>
          </p>
          <div class="inner">
            <slot name="inner"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { headerProps } from './index.js'
  import breadcrumb from '../crumbs/index.vue'
  import { TAB_PAGE_FRAME_STORAGE_KEY } from '../../business/layout-tab/constans'
  export default {
    name: 'header',
    props: headerProps,
    components: {
      breadcrumb
    },    
    data () {
      return {
        returnHide: false,
        headerHeight: 0,
        isFixed: false,
        headerWidth: 0,
        pageFrame: localStorage.getItem(TAB_PAGE_FRAME_STORAGE_KEY)
      }
    },
    computed: {
      routerPath () {
        // 菜单所属code，非列表页定位菜单使用
        let menuCode = this.$route.query.menuCode || this.$route.meta.menuCode
        let path = menuCode ?? this.$route.path
        let arr = path.split('')
        // 适配路由末尾带/而无法展开默认
        return arr[arr.length - 1] === '/' ? arr.slice(0, arr.length - 1).join('') : path
      }
    },
    created () {
      if (window.history.length === 1) {
        this.returnHide = true
      }
    },
    mounted () {
      window.addEventListener('scroll', this.scroll)
      this.$nextTick(() => {
        this.headerHeight = this.$refs.pageHeader.offsetHeight
      })
    },
    destroyed () {
      window.removeEventListener('scroll', this.scroll)
    },
    methods: {
      handleBack () {
        if (this.customFun) {
          this.customFun()
        } else {
          // this.$router.go(-1)
          // console.log(this.$syRouter)
          this.$syRouter ? this.$syRouter.back() : this.$router.go(-1)
        }
      },
      // 滚动条事件
      scroll () {
        // 714商城后台兼容
        if (this.pageFrame !== '1') {
          window?.fe && (this.$refs.headerContent.style.top = window.fe.project === 'mall' ? '73px' : '0')
        }
        /*let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        let offsetTop = this.$refs.headerContent ? this.$refs.headerContent.offsetTop : 0
        this.isFixed = scrollTop > offsetTop //是否吸顶*/
      },
      getHeaderHeight () {
        return this.headerHeight
      }
    }
  } 
</script>

<style lang="scss" scoped>
  // @import '@/common/css/variable.scss';
  $default-color: #fff;
  $font-color: #333;
  .header-content {
    width: 100%;
    margin: 8px 0;
    background-color: #fff;
    border-radius: 8px;
    min-height: 56px;
    position: sticky;
    top: 0;
    // left: 0;
    z-index: 600;
  }

  .position-header {
    position: fixed;
    z-index: 2000;
  }

  .header {
    width: 100%;
    min-width: 1200px;
    background-color: #fff;
    padding: 9px 24px 9px 16px;
    box-sizing: border-box;
    box-shadow: 0px 0 8px rgba(57, 121, 201, 0.14);
    border-radius: 8px;
    border: 1px solid #d6dfff;
    min-height: 56px;
  }

  .crumbs {
    margin: 3px 0 8px 0;
    .href-class {
      cursor: pointer;
    }

    .crumbs-default {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
    }
  }

  .page-header {
    background-color: $default-color;
    .header-inner {
      min-height: 36px;
      overflow: hidden;
      position: relative;
      box-sizing: border-box;
      font-weight: 500;
    }
    .header-title {
      height: 100%;
      line-height: 1;
      font-size: 18px;
      display: inline-block;
      // position: absolute;
      // top: 50%;
      // transform: translateY(-50%);
      min-width: 30%;
      text-align: left !important;
      .header-icon {
        color: #242F57;
        font-size: 24px;
        cursor: pointer;
        font-weight: 600;
        vertical-align: middle;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
      .header-text {
        color: #242F57;
        font-weight: 500;
        vertical-align: middle;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 32px;
      }
    }

    .step-container {
      width: 540px;
      float: right;

      &:after {
        content: '';
        clear: both;
        height: 0;
        visibility: hidden;
      }
    }

    .inner {
      float: right;
      line-height: 36px;
    }
  }
  .header-content .button-wrap {
      margin-bottom: 0 !important;
  }
</style>
